import axios from 'axios';
import { endLoader, startLoader } from '../component/loader/Loader';

// Create an instance of axios with base URL
const instance = axios.create({
    baseURL: `${process.env.REACT_APP_BASE_URI}/api`,
});

let requestCount = 0;

instance.interceptors.request.use(
    function (config) {
        // Start the loader before the request is sent
        if (!config?.bypassAuth && !config?.byPassLoader) {
            if (requestCount === 0) {
                // First request, start the loader
                startLoader();
            }
            requestCount++;
        }

        const accessToken = JSON.parse(localStorage.getItem('authToken'));
        if (accessToken) {
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        }
        return config;
    },
    function (error) {
        // TO stop top loader
        requestCount--;

        if (requestCount === 0) {
            // Last request, stop the loader
            endLoader();
        }

        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    function (response) {
        // TO stop top loader
        requestCount--;

        if (requestCount === 0) {
            // Last request, stop the loader
            endLoader();
        }

        return response;
    },
    function (error) {
        // TO stop top loader
        requestCount--;

        if (requestCount === 0) {
            // Last request, stop the loader
            endLoader();
        }

        if (error?.response?.status === 401) {
            localStorage.removeItem('authToken');
            window.location.reload();
        }
        return Promise.reject(error);
    }
);

export default instance;